import {useCallback} from "react";


export const useResetDefaults = ({
  defaults,
  parameters,
  modifications,
  plotAndValidateFields,
  multipleWidgetSetter}) => {

  return useCallback(
    () => {
      multipleWidgetSetter(defaults);
      plotAndValidateFields('_', defaults);
    },
    [defaults,
      plotAndValidateFields,
      multipleWidgetSetter]
  );
}